<template>
  <div style="padding-top: 4rem; padding-bottom: 4rem">
    <p
      align="center"
      style="
        font-family: Arial, Helvetica, sans-serif;
        font-size: 2.5rem;
        font-weight: 800;
        color: #1c3e8e;
      "
    >
      Bienvenidos a Nuestra Área de Vibrocomprimido
    </p>
    <divider-component />
    <div align="center">
      <p
        style="
          width: 50%;
          font-family: Arial, Helvetica, sans-serif;
          font-weight: 400;
        "
        align="center"
      >
        Nuestro compromiso con la calidad y la eficiencia nos ha llevado a
        desarrollar un área dedicada exclusivamente a la producción de
        vibrocomprimido, donde la precisión y la atención al detalle son el
        corazón de todo lo que hacemos.
      </p>
    </div>
  </div>

  <v-container>
    <v-row>
      <v-col
        cols="12"
        xs="12"
        sm="12"
        md="6"
        lg="4"
        v-for="(Item, i) in data"
        :key="i"
      >
        <card-info-component
          :id="Item.Id"
          :colores="Item.colores"
          :foto="Item.foto"
          :medidas="Item.medidas"
          :nombre="Item.titulo"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import CardInfoComponent from '@/components/CardInfoComponent.vue';
import DividerComponent from '@/components/DividerComponent.vue';
import ApiBloquera from '@/Api/BloqueraApi';
export default {
  components: { CardInfoComponent, DividerComponent },

  data() {
    return {
      data: [],

      Block: [
        {
          Id: '0001',
          nombre: 'BLOCK NORMAL',
          medidas: [
            {
              id: '001',
              medida: '13 x 19 x 39',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
            {
              id: '002',
              medida: '12 x 20 x 40',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
            {
              id: '003',
              medida: '11 x 19 x 39',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
          ],
          colores: [
            { id: '001', color: 'ROJO', costoAdicional: '6' },
            { id: '002', color: 'ROSA', costoAdicional: '6' },
            { id: '003', color: 'RUSTICO', costoAdicional: '6' },
            { id: '004', color: 'CAFE', costoAdicional: '6' },
            { id: '005', color: 'AMARILLO', costoAdicional: '6' },
            { id: '006', color: 'UVA', costoAdicional: '6' },
            { id: '007', color: 'NEGRO', costoAdicional: '6' },
          ],
          foto: 'https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/Bloquera%2Fblock%20normal.webp?alt=media&token=15ffa57f-a855-420b-8c4d-be53b400c70a',
        },
        {
          Id: '0002',
          nombre: 'BLOCK SOLIDO CON FIGURA',
          medidas: [
            {
              id: '004',
              medida: '13 x 19 x 39',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
          ],
          colores: [
            { id: '001', color: 'ROJO', costoAdicional: '6' },
            { id: '002', color: 'ROSA', costoAdicional: '6' },
            { id: '003', color: 'RUSTICO', costoAdicional: '6' },
            { id: '004', color: 'CAFE', costoAdicional: '6' },
            { id: '005', color: 'AMARILLO', costoAdicional: '6' },
            { id: '006', color: 'UVA', costoAdicional: '6' },
            { id: '007', color: 'NEGRO', costoAdicional: '6' },
          ],
          foto: 'https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/Bloquera%2Fblock%20solido%20con%20figura.webp?alt=media&token=2a5fe17f-ec18-41b7-b819-0c7c519d4883',
        },
        {
          Id: '0003',
          nombre: 'BLOCK TIPO FLAUTA',
          medidas: [
            {
              id: '005',
              medida: '13 x 19 x 39.5',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
          ],
          colores: [{ id: '001', color: 'RUSTICO', costoAdicional: '6' }],
          foto: 'https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/Bloquera%2FBlock%20tipo%20flauta.webp?alt=media&token=33ac6ae7-82e9-4f7f-9060-dff881ac25c8',
        },
        {
          Id: '0004',
          nombre: 'BLOCK CARA DE PIEDRA HUECO O SOLIDO',
          medidas: [
            {
              id: '006',
              medida: '15 x 19 x 39',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
            {
              id: '007',
              medida: '12 X 20 X 40',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
            {
              id: '008',
              medida: '15 X 20 X 40',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
            {
              id: '009',
              medida: '20 X 20 X 40',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
          ],
          colores: [
            { id: '001', color: 'ROJO', costoAdicional: '6' },
            { id: '002', color: 'ROSA', costoAdicional: '6' },
            { id: '003', color: 'RUSTICO', costoAdicional: '6' },
            { id: '004', color: 'CAFE', costoAdicional: '6' },
            { id: '005', color: 'AMARILLO', costoAdicional: '6' },
            { id: '006', color: 'UVA', costoAdicional: '6' },
            { id: '007', color: 'NEGRO', costoAdicional: '6' },
          ],
          foto: 'https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/Bloquera%2Fblock_cara_piedra_hueco_solido.webp?alt=media&token=c3027310-d4e6-4cbf-a960-5e7374ab00b2',
        },
        {
          Id: '0005',
          nombre: 'ADOCRETO TIPO Z',
          medidas: [
            {
              id: '010',
              medida: '20 X 11.5 X 8',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
          ],
          colores: [
            { id: '001', color: 'ROJO', costoAdicional: '6' },
            { id: '002', color: 'ROSA', costoAdicional: '6' },
            { id: '003', color: 'RUSTICO', costoAdicional: '6' },
            { id: '004', color: 'CAFE', costoAdicional: '6' },
            { id: '005', color: 'AMARILLO', costoAdicional: '6' },
            { id: '006', color: 'UVA', costoAdicional: '6' },
            { id: '007', color: 'NEGRO', costoAdicional: '6' },
          ],
          foto: 'https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/Bloquera%2Fadocreto%20tipo%20z.webp?alt=media&token=1261c8a0-06dc-4342-a9d0-4a24a6ef02e7',
        },
        {
          Id: '0006',
          nombre: 'ADOCRETO TIPO HUESO',
          medidas: [
            {
              id: '011',
              medida: '20 X 16.5 X 8',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
          ],
          colores: [
            { id: '001', color: 'ROJO', costoAdicional: '6' },
            { id: '002', color: 'ROSA', costoAdicional: '6' },
            { id: '003', color: 'RUSTICO', costoAdicional: '6' },
            { id: '004', color: 'CAFE', costoAdicional: '6' },
            { id: '005', color: 'AMARILLO', costoAdicional: '6' },
            { id: '006', color: 'UVA', costoAdicional: '6' },
            { id: '007', color: 'NEGRO', costoAdicional: '6' },
          ],
          foto: 'https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/Bloquera%2FAdocreto%20tipo%20hueso.webp?alt=media&token=f772e94c-9b90-4c31-b2d0-039022b32d3f',
        },
        {
          Id: '0007',
          nombre: 'ADOCRETO TIPO CRUZ',
          medidas: [
            {
              id: '012',
              medida: '20 X 20 X 8',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
          ],
          colores: [
            { id: '001', color: 'ROJO', costoAdicional: '6' },
            { id: '002', color: 'ROSA', costoAdicional: '6' },
            { id: '003', color: 'RUSTICO', costoAdicional: '6' },
            { id: '004', color: 'CAFE', costoAdicional: '6' },
            { id: '005', color: 'AMARILLO', costoAdicional: '6' },
            { id: '006', color: 'UVA', costoAdicional: '6' },
            { id: '007', color: 'NEGRO', costoAdicional: '6' },
          ],
          foto: 'https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/Bloquera%2Fadocreto%20tipo%20cruz.webp?alt=media&token=cb0e63fc-9ced-47f2-9eba-5716ce58792a',
        },
        {
          Id: '0008',
          nombre: 'ADOCRETO TIPO COCOL',
          medidas: [
            {
              id: '013',
              medida: '39 X 20 X 8',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
          ],
          colores: [
            { id: '001', color: 'ROJO', costoAdicional: '6' },
            { id: '002', color: 'ROSA', costoAdicional: '6' },
            { id: '003', color: 'RUSTICO', costoAdicional: '6' },
            { id: '004', color: 'CAFE', costoAdicional: '6' },
            { id: '005', color: 'AMARILLO', costoAdicional: '6' },
            { id: '006', color: 'UVA', costoAdicional: '6' },
            { id: '007', color: 'NEGRO', costoAdicional: '6' },
          ],
          foto: 'https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/Bloquera%2Fadocreto%20tipo%20cocol.webp?alt=media&token=44e50303-775d-49ef-ba3d-56a05440e7de',
        },
        {
          Id: '0009',
          nombre: 'ADOCRETO CUADRADO',
          medidas: [
            {
              id: '014',
              medida: '20 X 25 X 8',
              precio: '10.30',
              PrecioMillar: '10.10',
              cantidad: 0,
            },
          ],
          colores: [
            { id: '001', color: 'ROJO', costoAdicional: '6' },
            { id: '002', color: 'ROSA', costoAdicional: '6' },
            { id: '003', color: 'RUSTICO', costoAdicional: '6' },
            { id: '004', color: 'CAFE', costoAdicional: '6' },
            { id: '005', color: 'AMARILLO', costoAdicional: '6' },
            { id: '006', color: 'UVA', costoAdicional: '6' },
            { id: '007', color: 'NEGRO', costoAdicional: '6' },
          ],
          foto: 'https://firebasestorage.googleapis.com/v0/b/casacru-web.appspot.com/o/Bloquera%2Fadocreto%20tipo%20cuadrado.webp?alt=media&token=17af3b29-d303-4250-8462-45102a1ca3ba',
        },
      ],
    };
  },

  mounted() {
    this.GetAllItems();
  },
  methods: {
    async GetAllItems() {
      await ApiBloquera.getAll()
        .then((response) => {
          this.data = response.data;
        })
        .catch((error) => {
        
        });
    },
  },
};
</script>

<style></style>
